/* Isolated measurement adapter. No automatic initialization or document listeners. */
(function () {
  class CyoMeasurements {
    constructor(root) { this.root = root; this.sectionSelector = '[data-cyo-shopping]'; this.init(root); }

    getSection(el) {
      if (!el || !el.closest) return this.root;
      return el.closest(this.sectionSelector) || this.root;
    }

    getContainer(root = this.root) {
      return root && root.querySelector ? root : this.root;
    }

    getProductForm(root = this.root) {
      const container = this.getContainer(root);
      return (
        container.querySelector('[data-cyo-form]')
      );
    }

    isCustomSizeSelected(root = this.root) {
      const container = this.getContainer(root);
      return !!container.querySelector(
        'input[data-cyo-custom-size-option="true"]:checked, input[name="properties[Size]"][value*="Custom Size"]:checked'
      );
    }

    setFormProperty(form, name, value) {
      if (!form || !name) return;

      // form.elements includes the ERP input associated via form="..." outside the form.
      let input = Array.from(form.elements || form.querySelectorAll('input[type="hidden"]')).find((item) => {
        return item.getAttribute('name') === name;
      });

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }

      input.value = value;
    }

    clearCustomSizeProperties(root = this.root) {
      const container = this.getContainer(root);
      const form = this.getProductForm(container);
      if (!form) return;

      [
        'properties[Unit]',
        'properties[Bust]',
        'properties[Waist]',
        'properties[Under Bust]',
        'properties[Around Belly]',
        'properties[Hips]',
        'properties[Hollow to Floor]',
        'properties[Height (Bare Foot)]',
        'properties[Extra Length]'
      ].forEach((name) => {
        const input = Array.from(form.querySelectorAll('input[type="hidden"]')).find((item) => {
          return item.getAttribute('name') === name;
        });
        if (input) input.remove();
      });

      // Properties-mode standard sizes must not retain the previous Custom Size ERP flag.
      if (!container.querySelector('[data-cyo-erp-size-input]')) {
        const staleSize = form.querySelector('input[name="properties[_Size]"]');
        if (staleSize) staleSize.remove();
      }

      container.querySelectorAll('.is-error').forEach((item) => {
        item.classList.remove('is-error');
      });

      const errorBox = container.querySelector('[data-cyo-error-message]');
      if (errorBox) errorBox.innerHTML = '';

      const notice = container.querySelector('.return_support_notice, .return_support_notice_inner');
      if (notice) notice.classList.remove('is-error');
    }

    updateUnitLabels(customBox, unit) {
      if (!customBox) return;
      const unitLabel = unit === 'cm' ? '(cm)' : '(in)';
      const control = customBox.querySelector('.unit-switch');
      if (control) {
        control.setAttribute('role', 'switch');
        control.setAttribute('aria-checked', String(unit === 'cm'));
        control.setAttribute('aria-label', 'Use centimeters');
        control.setAttribute('data-cyo-current-unit', unit);
        control.tabIndex = 0;
      }

      customBox.querySelectorAll('.unit_item').forEach((item) => {
        const textNode = Array.from(item.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE && /\((in|cm)\)/.test(node.nodeValue || '')
        );
        if (textNode) textNode.nodeValue = unitLabel;
      });
    }

    rebuildCustomSizeSelects(customBox, unit) {
      if (!customBox) return;

      customBox.querySelectorAll('.custom-size-select, .dress_ul select').forEach((select) => {
        const valuesRaw =
          unit === 'cm'
            ? select.getAttribute('data-cyo-cm-values')
            : select.getAttribute('data-cyo-inch-values');

        if (!valuesRaw) {
          console.warn('Missing custom size values:', unit, select);
          return;
        }

        const values = valuesRaw
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);

        select.innerHTML = '';

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = '-- Please Select --';
        select.appendChild(placeholder);

        values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.appendChild(option);
        });

        select.value = '';
        select.classList.remove('is-error');
      });
    }

    syncMeasurePreview(root = this.root) {
      const scope = root && root.querySelectorAll ? root : this.root;
      const pickers = [];

      if (scope.matches && scope.matches('[data-cyo-product-size-picker]')) {
        pickers.push(scope);
      } else {
        scope.querySelectorAll('[data-cyo-product-size-picker]').forEach((picker) => {
          pickers.push(picker);
        });
      }

      pickers.forEach((picker) => this._syncOneMeasurePreview(picker));
    }

    _syncOneMeasurePreview(picker) {
      if (!picker) return;
      const preview = picker.querySelector('[data-cyo-size-measure-preview]');
      if (!preview) return;

      const checked = picker.querySelector('.size-item-list input[type="radio"]:checked');
      const isCustom =
        !checked ||
        checked.hasAttribute('data-cyo-custom-size-option') ||
        /custom size/i.test(checked.value || '');

      if (isCustom) {
        preview.style.display = 'none';
        return;
      }

      preview.style.display = '';
      const erp = checked.getAttribute('data-cyo-erp-size-value') || checked.value || '';
      const optionVal = checked.value || '';
      const sizeCode = optionVal.replace(/\s+/g, '');

      preview.querySelectorAll('tbody tr').forEach((tr) => {
        const match =
          (erp && tr.getAttribute('data-cyo-erp') === erp) ||
          tr.getAttribute('data-cyo-option') === optionVal ||
          tr.getAttribute('data-cyo-option-alt') === optionVal ||
          tr.getAttribute('data-cyo-size-code') === sizeCode;

        tr.style.display = match ? 'table-row' : 'none';
        tr.classList.toggle('active', Boolean(match));
      });
    }

    init(root = this.root) {
      this.initCustomSizeUnit(root);
      this.toggleCustomSizeFields(root);
      this.syncErpSizeProperty(root);
      this.syncMeasurePreview(root);
    }

    initCustomSizeUnit(root = this.root) {
      const container = this.getContainer(root);
      const customBox = container.querySelector('[data-cyo-custom-size-box]');
      if (!customBox) return;

      const switchBtn = customBox.querySelector('.unit-switch');
      const currentUnit = switchBtn && switchBtn.classList.contains('right') ? 'cm' : 'inch';

      this.rebuildCustomSizeSelects(customBox, currentUnit);
      this.updateUnitLabels(customBox, currentUnit);
    }

    toggleCustomSizeFields(root = this.root) {
      const container = this.getContainer(root);
      const customBox = container.querySelector('[data-cyo-custom-size-box]');
      if (!customBox) return;

      if (this.isCustomSizeSelected(container)) {
        customBox.style.display = 'block';
      } else {
        customBox.style.display = 'none';
        this.clearCustomSizeProperties(container);
      }
    }

    toggleCustomUnit(switchBtn, root = this.root) {
      const customBox = switchBtn.closest('[data-cyo-custom-size-box]');
      if (!customBox) return;

      const currentUnit = switchBtn.classList.contains('right') ? 'cm' : 'inch';
      const nextUnit = currentUnit === 'inch' ? 'cm' : 'inch';

      switchBtn.classList.toggle('left', nextUnit === 'inch');
      switchBtn.classList.toggle('right', nextUnit === 'cm');
      switchBtn.setAttribute('data-cyo-current-unit', nextUnit);

      this.rebuildCustomSizeSelects(customBox, nextUnit);
      this.updateUnitLabels(customBox, nextUnit);

      const errorBox = customBox.querySelector('[data-cyo-error-message]');
      if (errorBox) errorBox.innerHTML = '';

      this.clearCustomSizeProperties(root);
    }

    syncErpSizeProperty(root = this.root) {
      const container = this.getContainer(root);
      const erpInput = container.querySelector('[data-cyo-erp-size-input]');
      if (!erpInput) return;

      if (this.isCustomSizeSelected(container)) {
        erpInput.value = 'Custom Size';
        return;
      }

      const checkedSizeInput = container.querySelector('input[data-cyo-erp-size-value]:checked');
      if (checkedSizeInput) {
        erpInput.value = checkedSizeInput.getAttribute('data-cyo-erp-size-value') || '';
        return;
      }

      const sizeSelect = Array.from(container.querySelectorAll('select[data-cyo-option-name]')).find((select) => {
        const normalized = String(select.getAttribute('data-cyo-option-name') || '')
          .toLowerCase()
          .trim()
          .replace(/ß/g, 'ss')
          .replace(/ö/g, 'oe')
          .replace(/ü/g, 'ue')
          .replace(/ä/g, 'ae')
          .replace(/ñ/g, 'n');
        return (
          normalized === 'size' ||
          normalized === 'grosse' ||
          normalized === 'groesse' ||
          normalized === 'taille' ||
          normalized === 'taglia' ||
          normalized === 'tamano'
        );
      });

      if (sizeSelect && sizeSelect.selectedOptions && sizeSelect.selectedOptions[0]) {
        erpInput.value = sizeSelect.selectedOptions[0].getAttribute('data-cyo-erp-size-value') || '';
        return;
      }

      erpInput.value = '';
    }

    validateAndGenerateCustomSize(root = this.root) {
      const container = this.getContainer(root);
      const form = this.getProductForm(container);
      const customBox = container.querySelector('[data-cyo-custom-size-box]');
      const errorBox = container.querySelector('[data-cyo-error-message]');

      if (!form || !customBox) return true;

      if (!this.isCustomSizeSelected(container)) {
        this.clearCustomSizeProperties(container);
        return true;
      }

      const missing = [];
      const switchBtn = customBox.querySelector('.unit-switch');
      const currentUnit = switchBtn && switchBtn.classList.contains('right') ? 'cm' : 'inch';

      this.setFormProperty(form, 'properties[Unit]', currentUnit);
      this.setFormProperty(form, 'properties[_Size]', 'Custom Size');

      customBox.querySelectorAll('.dress_ul select, .custom-size-select').forEach((select) => {
        const value = select.value ? select.value.trim() : '';
        const optionName = select.getAttribute('data-cyo-option') || 'Measurement';
        const propertyName = select.getAttribute('data-cyo-name');
        if (!propertyName) return;

        if (!value) {
          missing.push(optionName);
          select.classList.add('is-error');
        } else {
          select.classList.remove('is-error');
          this.setFormProperty(form, propertyName, value);
        }
      });

      const checkbox = customBox.querySelector('[name="return_support_checkbox"]');
      const notice = customBox.querySelector('.return_support_notice, .return_support_notice_inner');

      if (!checkbox || !checkbox.checked) {
        missing.push('terms and conditions');
        if (notice) notice.classList.add('is-error');
      } else if (notice) {
        notice.classList.remove('is-error');
      }

      if (missing.length) {
        if (errorBox) {
          errorBox.innerHTML = `<span class="error">Please provide: ${missing.join(', ')}</span>`;
        }
        return false;
      }

      if (errorBox) errorBox.innerHTML = '';
      return true;
    }

  }
  window.CyoMeasurements = CyoMeasurements;
})();
